<div class="w-100 mt-3">
    <!-- ---------------------------------------------------------CRM Footer Start------------------------------------------------------------------ -->

    <div class="row">
        <div class="container-fluid text-center py-3" style="background-color: black;">
            <a href="javascript:void(0);" style="color:white;" (click)="gotoTop()">Back to top</a>
        </div>

        <div class="container-fluid" style="background-color: #232f3e; padding-bottom: 20px;">
            <div class="row text-white" style="margin-left: 60px; padding-bottom: 30px; padding-top: 30px;">
                <div class="col-md-2"></div>
                <div class="col-md-2 mb-3">
                    <h3 style="font-size: 18px;">All</h3>
                    <a href="javascript:void(0);" class="footer-link-text d-block py-1" [routerLink]="['dashboard']">
                        <span>Dashboard</span>
                    </a>
                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(100,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['students']">
                        <span>Student</span>
                    </a>

                    <!-- <a href="javascript:void(0);"*ngIf="validateMenuPrivilage(102,8) && isEnable" class="footer-link-text d-block py-1">
                        <span>Universities</span>
                    </a> -->

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(101,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['courses']">
                        <span>Courses</span>
                    </a>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(105,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['associate']">
                        <span>Associates</span>
                    </a>
                </div>
                <div class="col-md-2 mb-3">
                    <h3 style="font-size: 18px;">Employee</h3>
                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(106,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['employee']">
                        <span>Employee</span>
                    </a>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(107,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['partner']">
                        <span>Partner</span>
                    </a>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(103,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['applications']">
                        <span>Application</span>
                    </a>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(108,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['templates']">
                        <span>Templates</span>
                    </a>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(115,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['tasks']">
                        <span>Tasks</span>
                    </a>

                </div>
                <div class="col-md-2 mb-3">
                    <h3 style="font-size: 18px;">Events</h3>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(109,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['events']">
                        <span>Events</span>
                    </a>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(110,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['subjects']">
                        <span>Subjects</span>
                    </a>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(121,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['swm']" >
                        <span>SWM</span>
                    </a>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(104,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['attendances']">
                        <span>Attendances</span>
                    </a>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(116,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['appointments']">
                        <span>Appointment</span>
                    </a>
                </div>
                <div class="col-md-2 mb-3">
                    <h3 style="font-size: 18px;">Course</h3>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(134,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['lessonplanlog']">
                        <span>Lesson Plan & Logs</span>
                    </a>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(129,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['downloadcenter']">
                      <span>Download Center</span>
                  </a>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(132,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['myworktask']">
                        <span>My Work Tasks</span>
                    </a>

                    <a href="javascript:void(0);" *ngIf="validateMenuPrivilage(131,8) && isEnable" class="footer-link-text d-block py-1" [routerLink]="['mainmywork']">
                        <span>My Works</span>
                    </a>

                    <!-- <a href="javascript:void(0);" class="footer-link-text d-block py-1">
                        <span>Case Study Download</span>
                    </a> -->

                </div>
                <div class="col-md-2"></div>
            </div>
            <hr style="border: 1px solid;" />
            <img [attr.src]="tenantLogo" style="display: block; margin-left: auto; margin-right: auto; width: 200px; object-fit: contain;" />
        </div>
    </div>
    <!-- ---------------------------------------------------------CRM Footer Start------------------------------------------------------------------ -->

</div>
